// removed by extract-text-webpack-plugin
module.exports = {"CartFooter":"src-components-Cart-Footer-__CartFooter-module___CartFooter"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Footer/CartFooter.module.css
// module id = 1219
// module chunks = 1